module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"/opt/build/repo/node_modules/gatsby-netlify-i18n-workaround/static/icons/favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"a3bb91e21960f330d4cb32032c99ab4c"},
    },{
      plugin: require('../node_modules/gatsby-netlify-i18n-workaround/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
